import { create } from "zustand";

export const useEc2ZustandStore = create((set) => ({
  ec2ZustandEditData: null, // State for EC2 edit data
  setEc2ZustandEditData: (data) => set({ ec2ZustandEditData: data }), // Setter for ec2ZustandEditData
}));
